import { ArrayHelpers, connect, FieldArray } from "formik";
import { FormControlLabel, Grid, Switch, Typography, Button, Icon, Divider, IconButton } from "@mui/material";
import DeleteIcon from '@mui/icons-material/Delete';
import Maybe from "../../../components/common/Maybe";
import Individual from "./Individual";
import { initialPrimaryInsuredValues, PrimaryInsured, RequestFamilyMember } from "../../purchase/PurchaseData.interface";
import { HelpIconInterface, Microcopy } from "../../../utilities/contentful";

const micro = new Microcopy;

const FamiliesRequest = (props: { helpIcons: HelpIconInterface[], formik?: any, primaryInsured: Partial<PrimaryInsured>[], microcopy: any }): JSX.Element => {

  return (

    <FieldArray
      name="primaryInsured"
      render={(arrayHelpers: ArrayHelpers) => {
        return (
          <>

            {
              props.primaryInsured?.map((insured, index) => (
                <div key={index} style={{ marginBottom: index + 1 < props.primaryInsured.length ? 20 : 0 }}>
                  <Maybe test={index > 0}>
                    <Divider style={{ marginTop: 25, marginBottom: 20 }} />
                  </Maybe>

                  <Grid container rowSpacing={2} columnSpacing={4} sx={{ justifyContent: 'space-between' }}>
                    <Grid item>
                      <Typography variant="h6" color="text.primary" fontWeight={700} gutterBottom>
                        Primary Insured {props.primaryInsured.length > 1 ? ` #${index + 1}` : ''}
                      </Typography>
                    </Grid>

                    <Maybe test={index > 0 || props.formik.values.primaryInsured.length > 1}>
                      <Grid item>
                        <IconButton color="error" aria-label="delete" onClick={() => { arrayHelpers.remove(index); }}>
                          <DeleteIcon />
                        </IconButton>
                      </Grid>
                    </Maybe>
                  </Grid>

                  <Individual helpIcons={props.helpIcons} fieldName={`primaryInsured.${index}`} individual={insured} microcopy={props.microcopy} />

                  <Grid container rowSpacing={2} columnSpacing={4} mt={1}>
                    <Grid item xs={12} sm={6}>
                      <FormControlLabel
                        control={
                          <Switch
                            disabled={props.formik.isSubmitting}
                            onChange={(e) => {
                              props.formik.setFieldValue(`primaryInsured.${index}.spouse.citizenshipObject`, insured.citizenshipObject);
                              props.formik.setFieldValue(`primaryInsured.${index}.spouse.residencyCountryObject`, insured.residencyCountryObject);
                              props.formik.setFieldValue(`primaryInsured.${index}.spouse.residencyStateObject`, insured.residencyStateObject);
                              props.formik.setFieldValue(`primaryInsured.${index}.spouse.tripCost`, insured.tripCost);
                              props.formik.setFieldValue(`primaryInsured.${index}.spouse.genderObject`, null);
                              props.formik.setFieldValue(`primaryInsured.${index}.spouse.age`, '');

                              props.formik.handleChange(`primaryInsured.${index}.hasSpouse`)(e);
                            }}
                          />
                        }
                        label="Add Spouse"
                        name={`primaryInsured.${index}.hasSpouse`}
                        checked={insured.hasSpouse}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <FormControlLabel
                        control={
                          <Switch
                            disabled={props.formik.isSubmitting}
                            onChange={(e) => {
                              props.formik.setFieldValue(`primaryInsured.${index}.children.0.citizenshipObject`, insured.citizenshipObject);
                              props.formik.setFieldValue(`primaryInsured.${index}.children.0.residencyCountryObject`, insured.residencyCountryObject);
                              props.formik.setFieldValue(`primaryInsured.${index}.children.0.residencyStateObject`, insured.residencyStateObject);
                              props.formik.setFieldValue(`primaryInsured.${index}.children.0.tripCost`, insured.tripCost);
                              props.formik.setFieldValue(`primaryInsured.${index}.children.0.genderObject`, null);
                              props.formik.setFieldValue(`primaryInsured.${index}.children.0.age`, '');

                              props.formik.handleChange(`primaryInsured.${index}.hasChildren`)(e);
                            }}
                          />
                        }
                        label="Add children"
                        name={`primaryInsured.${index}.hasChildren`}
                        checked={insured.hasChildren}
                      />
                    </Grid>
                  </Grid>

                  <Maybe test={insured.hasSpouse}>
                    <Typography variant="subtitle1" color="text.primary" fontWeight={700} gutterBottom mt={2}>
                      Spouse
                    </Typography>

                    <Individual helpIcons={props.helpIcons} fieldName={`primaryInsured.${index}.spouse`} individual={insured.spouse as RequestFamilyMember} microcopy={props.microcopy} />
                  </Maybe>

                  <Maybe test={insured.hasChildren}>
                    <FieldArray
                      name={`primaryInsured.${index}.children`}
                      render={(childArrayHelpers: ArrayHelpers) => {
                        return (
                          <>
                            {
                              props.formik.values.primaryInsured[index].children?.map((child: Partial<RequestFamilyMember>, childIndex: any) => (
                                <div key={`${index}-${childIndex}`}>
                                  <Grid container item mt={2} sx={{ justifyContent: 'space-between' }}>
                                    <Typography variant="subtitle1" color="text.primary" fontWeight={700} >
                                      Child {insured.children?.length as number > 1 ? ` #${childIndex + 1}` : ''}
                                    </Typography>

                                    <Maybe test={insured.children?.length as number > 1}>
                                      <IconButton color="error" aria-label="delete" onClick={() => { childArrayHelpers.remove(childIndex); }}>
                                        <DeleteIcon />
                                      </IconButton>
                                    </Maybe>
                                  </Grid>

                                  <Individual helpIcons={props.helpIcons} fieldName={`primaryInsured.${index}.children.${childIndex}`} individual={child} microcopy={props.microcopy} />
                                </div>
                              ))
                            }

                            <Button
                              style={{ marginTop: 20 }}
                              variant="outlined"
                              color="info"
                              size={"small"}
                              type="button"
                              disabled={props.formik.isSubmitting}
                              onClick={() => {
                                childArrayHelpers.push({
                                  age: '',
                                  genderObject: null,
                                  citizenshipObject: insured.citizenshipObject,
                                  residencyCountryObject: insured.residencyCountryObject,
                                  residencyStateObject: insured.residencyStateObject,
                                  tripCost: insured.tripCost,
                                })
                              }}
                            >
                              <Icon style={{ marginRight: 5 }}>person_add</Icon> {micro.getFromKey('button.add-child', props.microcopy)}
                            </Button>
                          </>
                        )
                      }}
                    />
                  </Maybe>
                </div>
              ))
            }

            <Typography color={'error'} variant={'body1'} fontWeight={600} mt={1}>
              {
                typeof props.formik.errors.primaryInsured === 'string' 
                && props.formik.values.primaryInsured.length === 0
                && props.formik.errors.primaryInsured
              }
            </Typography>

            <Divider style={{ marginTop: 20, marginBottom: 20 }} />

            <Button 
              variant="outlined" 
              size={"small"} 
              type="button" 
              onClick={() => {arrayHelpers.push(initialPrimaryInsuredValues)}}
              disabled={props.formik.isSubmitting}
            >
              <Icon style={{ marginRight: 5 }}>person_add</Icon> {micro.getFromKey('button.add-insured', props.microcopy)}
            </Button>
          </>
        )
      }
      }
    />
  );
}

export default connect(FamiliesRequest);